import { render } from "./ExcelDown.vue?vue&type=template&id=00162759&ts=true"
import script from "./ExcelDown.vue?vue&type=script&lang=ts"
export * from "./ExcelDown.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__